<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
            <div>
                <v-row justify="center">
                    <v-col class="text-center">
                        <div class="text-uppercase font-weight-bold primary--text text-h5">
                            Editar banco
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="5">
                        <v-form ref="form" @submit.prevent="save">
                            <vendedor-form :values="form" :rules="rules"></vendedor-form>
                        </v-form>
                    </v-col>
                </v-row>

            </div>
			<v-row justify="center" align="end">
				<v-col cols="12" md="5" class="text-right">
					<v-btn class="full-width-btn" text color="primary" :to="{ name: 'Bancos' }">Cancelar</v-btn>
					<v-btn tile color="secondary" class="ml-md-2 ml-0 mt-md-0 mt-3 full-width-btn text-base-color" @click="save">Guardar</v-btn>
				</v-col>
			</v-row>
            <snackbar :props="snackbarProps"></snackbar>
        </template>
    </contentCard>
</template>

<script>
import VendedorForm from "./Form.vue";
export default {
    components: {
        'vendedor-form': VendedorForm,
    },
	data(){
		return {
            id: this.$route.params.id,
            loading: false,
            form: {
                type: '',
                bank_id: '',
                alias: '',
                account_number: '',
                initial_balance: '',
                initial_balance_date: '',
            },
            rules: {
                bank_id: [
                    v => !!v || 'Banco es requerido'
                ],
                alias: [
                    
                ],
                account_number: [
                    v => !!v || 'Número de cuenta es requerido',
                    v => /^[0-9]*$/.test(v) || 'Cuenta sólo debe contener números',
                ],
                initial_balance: [
                    v => !!v || 'Saldo inicial es requerido',
                    v => /^(\d*\.)?\d+$/.test(v) || 'Saldo inicial debe ser númerico'
                ],
                initial_balance_date: [
                    v => !!v || 'Fecha de saldo inicial es requerido'
                ],
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        this.index()
    },
	methods: {
		validate () {
			return this.$refs.form.validate()
        },
        index(){
            this.loading = true
            this.$http.get(this.$store.state.apiRoute+'/banks/'+this.id+'/edit')
            .then((response) => {
                this.form = response.data
            })
            .catch(error => {
                error
            })
            .finally(() => {
                this.loading = false
            })
        },
        save(){
            this.$store.state.overlay = true

            if(this.validate()){               
                this.$http.put(this.$store.state.apiRoute+'/banks/'+this.id+'/update', this.form)
                .then((response) => {
                    response.data

                    this.$store.state.globalSnackbarProps.visible = true
                    this.$store.state.globalSnackbarProps.text = 'Se ha actualizado correctamente el banco <b>'+this.form.alias+'</b>'
                    this.$router.push({ name: 'Bancos' })
                })
                .catch((error) => {
                    var errors = []
                    switch(error.response.status){
                        case 422: 
                            Object.keys(error.response.data.errors).forEach((x) => {
                                error.response.data.errors[x].forEach((y) => {
                                    errors.push(y)
                                })
                            })
                        break;
                        case 500: 
                            errors.push('Error en el servidor. Intente de nuevo.')
                        break;
                        case 404: 
                            errors.push('No encontrado.')
                        break;
                    }

                    this.snackbarProps = {
                        visible: true,
                        color: 'error',
                        timeout: 10000,
                        text: errors.join('.<br>'),
                    }
                })
                .finally(() => {
                    this.$store.state.overlay = false
                })
            }else{
                this.snackbarProps = {
                    visible: true,
                    color: 'error',
                    timeout: 2000,
                    text: 'Formulario incompleto',
                }

                this.$store.state.overlay = false
            }
            // eslint-disable-next-line no-console
        }
    },
}
</script>

<style>

</style>